import Component from '@glimmer/component';
import Select from 'tio-ui/components/select';
import { AVAILABLE_DATASETS, sqlDatasets } from '../utils/dataset-utils';

interface DatasetSelectorSignature {
  Args: {
    selectedDataset: string;
    onDatasetChange: (dataset: string) => void;
    disabled?: boolean;
    /**
     * Opt-in for RFC 062 SQL datasets (report builder only). The module
     * registry outlives the /reports route that fills it, so surfaces that
     * can't query SQL datasets (dashboard widgets, tas-programs pages) must
     * not list them — a widget saved with a SQL slug would silently fall
     * back to the Person index on a fresh session.
     */
    includeSqlDatasets?: boolean;
  };
}

export default class DatasetSelector extends Component<DatasetSelectorSignature> {
  // SQL datasets appear alongside the OpenSearch ones — same option shape,
  // no visual distinction (RFC 062: the builder can't tell). Empty unless
  // the app registered published SQL datasets.
  get datasetOptions() {
    const sql = this.args.includeSqlDatasets ? sqlDatasets() : [];
    return [...AVAILABLE_DATASETS, ...sql].map((dataset) => ({
      key: dataset.key,
      label: dataset.label,
    }));
  }

  <template>
    <div class="shrink-0 min-w-[200px]" data-test-dataset-selector>
      <Select
        @items={{this.datasetOptions}}
        @selected={{@selectedDataset}}
        @onChange={{@onDatasetChange}}
        @size="sm"
        @placeholder="Select dataset"
      />
    </div>
  </template>
}
